class BillingList {
    id = null;
    user_id = null;
    invoice_total_gross = null;
    invoice_total_net = null;
    payslip_total_net = null;
    invoice_to = null;
    billing_period_from = null;
    billing_period_to = '';
    confirmed = false;
    archive = false;
    gdpr_edit_lock = false;
    information = null;
    net_difference = null;

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default BillingList;
